import React, { useEffect, useState } from 'react';
import Overview from '../Overview/Overview';
import { Frame, Page } from '@shopify/polaris';

const KioskOverview = (props) => {
  const { i18n, floatingSetupGuide, setFloatingSetupGuide, domain } = props;
  const [subHeaderData, setSubHeaderData] = useState();
  const fetchReports = () => {
    fetch(`/upsell/fetch_analytics?shopify_domain=${domain}`, {
      method: 'GET',
    })
      .then((r) => r.json())
      .then((data) => {
        let subheaderdata = [
          {
            title: 'Revenue',
            value: data?.total_revenue || '0',
            desc: ` `,
          },
          {
            title: 'Views',
            value: data?.views || '0',
            desc: ` `,
          },
          {
            title: 'Conversion Rate',
            value: data?.conversion_rate || '0',
            desc: ` `,
          },
        ];
        setSubHeaderData([...subheaderdata]);
      });
  };
  useEffect(() => {
    fetchReports();
  }, []);

  return (
    <Frame>
      <Page>
        <div className="chargezen_custom_page_header">
          <div className="page_title_wrapper">
            <div className="back_button_wrapper">
              <div class="text_wrapper page_heading_title_wrapper">
                <div
                  class="Polaris-Header-Title__TitleAndSubtitleWrapper"
                  style={{
                    width: '100%',
                  }}
                >
                  <div class="Polaris-Header-Title">
                    <h1 class="Polaris-DisplayText Polaris-DisplayText--sizeLarge">
                      <span class="Polaris-TextStyle--variationStrong">
                        <div class="back_button_wrapper">
                          {' '}
                          <div
                            class="text_wrapper page_heading_title_wrapper"
                            style={{
                              width: '100%',
                            }}
                          >
                            <span>Kiosk Overview</span>
                          </div>
                        </div>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sidebar_summary header_description">
            Everything you need to run a membership focused restaurant and meal delivery box - online menus, retail self-serve menus,
reservations management, SMS, whatsapp & QR code ordering; mix-and-match bundles and more.
          </div>
        </div>
        <>
          <div className={`chargezen_full_width_main_container`}>
            <div className={`chargezen_full_width_container`}>
              <div className={`chargezen_full_width_wrapper`}>
                <Overview
                  {...{
                    i18n,
                    floatingSetupGuide,
                    setFloatingSetupGuide,
                    subHeaderData,
                  }}
                  customNavTabs={{ kiosk_pos: true }}
                />
              </div>
            </div>
          </div>
        </>
      </Page>
    </Frame>
  );
};

export default KioskOverview;
